import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ListItemButton, ListItemText } from '@mui/material';

import { closeDrawer } from 'main/store/common/reducer';

type Props = {
    label: string;
    path: string;
    pl?: number;
}

export const MenuItem = ({ label, path, pl }: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleClick = useCallback((path: string) => {
        return () => {
            dispatch(closeDrawer());
            navigate(path);
        }
    }, [dispatch, navigate]);

    return (
        <ListItemButton onClick={handleClick(path)} sx={{ pl }}>
            <ListItemText>{label}</ListItemText>
        </ListItemButton>
    )
}
